import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Switch,
  FormControlLabel
} from '@mui/material'
import PropTypes from 'prop-types'
import TemplateVariableInput from './TemplateVariableInput'

const TemplateDialog = ({
  open,
  onClose,
  template,
  onSave,
  isEditing = false
}) => {
  const [localTemplate, setLocalTemplate] = React.useState({
    name: '',
    subject: '',
    body: '',
    from_email: 'support@vetavirtual.com',
    include_dashboard_button: true
  })

  React.useEffect(() => {
    if (template) {
      setLocalTemplate(template)
    } else {
      setLocalTemplate({
        name: '',
        subject: '',
        body: '',
        from_email: 'support@vetavirtual.com',
        include_dashboard_button: true
      })
    }
  }, [template, open])

  const handleSave = () => {
    onSave(localTemplate)
  }

  const updateTemplate = (updates) => {
    setLocalTemplate(prev => ({ ...prev, ...updates }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ style: { backgroundColor: 'var(--color-card-bg)', color: 'var(--color-text-primary)' } }}
    >
      <DialogTitle style={{ color: 'var(--color-text-primary)' }}>
        {isEditing ? 'Edit Template' : 'Create New Template'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Template Name"
          fullWidth
          value={localTemplate.name}
          onChange={(e) => updateTemplate({ name: e.target.value })}
          required
        />

        <TemplateVariableInput
          margin="dense"
          label="Subject Line"
          fullWidth
          value={localTemplate.subject}
          onChange={(e) => updateTemplate({ subject: e.target.value })}
          required
        />

        <TextField
          margin="dense"
          label="From Email"
          fullWidth
          value={localTemplate.from_email}
          onChange={(e) => updateTemplate({ from_email: e.target.value })}
          required
        />

        <TemplateVariableInput
          margin="dense"
          label="Email Body"
          multiline
          rows={8}
          fullWidth
          value={localTemplate.body}
          onChange={(e) => updateTemplate({ body: e.target.value })}
          required
          helperText="Available variables: {campaign_name}, {usage_percent}, {plan_minutes}, {current_month_minutes}"
        />

        <FormControlLabel
          control={
            <Switch
              checked={localTemplate.include_dashboard_button}
              onChange={(e) => updateTemplate({ include_dashboard_button: e.target.checked })}
              color="primary"
            />
          }
          label="Include Dashboard Button"
          style={{ marginTop: 16 }}
        />

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained"
          disabled={!localTemplate.name.trim() || !localTemplate.subject.trim() || !localTemplate.body.trim()}
        >
          {isEditing ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

TemplateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  template: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  isEditing: PropTypes.bool
}

export default TemplateDialog